var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4073_51197)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77804 14.835C6.03519 15.9484 7.6887 16.6244 9.50008 16.6244C11.3115 16.6244 12.965 15.9484 14.2221 14.835C13.9904 14.0018 12.3258 13.4577 9.50008 13.4577C6.67432 13.4577 5.00975 14.0018 4.77804 14.835ZM3.64215 13.5564C4.53313 12.3795 6.62681 11.8743 9.50008 11.8743C12.3734 11.8743 14.467 12.3795 15.358 13.5564C16.1569 12.405 16.6251 11.0069 16.6251 9.49935C16.6251 5.56432 13.4351 2.37435 9.50008 2.37435C5.56505 2.37435 2.37508 5.56432 2.37508 9.49935C2.37508 11.0069 2.84326 12.405 3.64215 13.5564ZM9.50008 18.2077C4.6906 18.2077 0.791748 14.3088 0.791748 9.49935C0.791748 4.68987 4.6906 0.791016 9.50008 0.791016C14.3096 0.791016 18.2084 4.68987 18.2084 9.49935C18.2084 14.3088 14.3096 18.2077 9.50008 18.2077ZM6.33342 7.91602C6.33342 6.13933 7.58354 4.74935 9.50008 4.74935C11.4113 4.74935 12.6667 6.2706 12.6667 8.07435C12.6667 10.6707 11.2561 11.8743 9.50008 11.8743C7.72743 11.8743 6.33342 10.6294 6.33342 7.91602ZM7.91675 7.91602C7.91675 9.71251 8.5645 10.291 9.50008 10.291C10.4324 10.291 11.0834 9.73558 11.0834 8.07435C11.0834 7.0851 10.4625 6.33268 9.50008 6.33268C8.49763 6.33268 7.91675 6.97854 7.91675 7.91602Z",
    fill: "#8139d0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4073_51197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a8e5ccf390d9e16a2137ae9a0e414fb6.svg";
export { ForwardRef as ReactComponent };